module.exports = __webpack_public_path__ + "img/Slideshow-flow-video-immo.8faa5372.png";